(function () {
    'use strict';
    angular.module('SMART2').directive('smartBack', ['$timeout','persistenceService', '$rootScope', function ($timeout, persistenceService, $rootScope) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                callback: "&"
            },
            link: function (scope, element, attrs) {
               
                //click callback
                var callback = scope.$eval(scope.callback);
                
                if(!persistenceService.nPlusOne.historyIsEmpty()){
                    scope.show=true;
                }
                
                //Local click binding
                scope.goBackClick = function (e) {
                    if (!scope.disable) {
                        if (angular.isFunction(callback)) {
                            callback(e)
                        };
                        persistenceService.redirectToPreviousNode();
                    }
                };

            },
            templateUrl: 'shared/directives/uiElements/smartBack/smartBackTemplate.html'
        };
    }]);
})();